import React from 'react';
import { HERO } from '../constants/config';

function QuoteBlock() {
  return (
    <figure className="rounded-xl border border-white/30 bg-indigo-950/55 p-4 sm:p-5 md:p-6">
      <blockquote
        className="text-sm font-medium italic text-white sm:text-base md:text-lg"
        cite="#hero-quote"
      >
        <p>{HERO.quote}</p>
      </blockquote>
      <figcaption className="mt-3 block text-right text-xs font-semibold text-indigo-100 sm:mt-4 sm:text-sm">
        — {HERO.quoteAuthor}
      </figcaption>
    </figure>
  );
}

export default QuoteBlock;
